import React from 'react';
import { Stack } from '@mui/material';
import HandsetColorSelector from './HandsetColorSelector';
import HandsetTitle from './HandsetTitle';
import { getCookie } from '../../hooks/useCookie';
import HandsetSpecification from './HandsetSpecification';
import HandsetStorageSelector from './HandsetStorageSelector';
import StandalonePortingToggle from '../eir-standalone-handset/StandalonePortingToggle';
import HandsetsSimTypeSelector from '../eir-simtype-selector/handsetsSimTypeSelector';
import ESIMOnlyHansetInfo from '../eir-simtype-selector/eSIMOnlyHandsetInfo';
import PrepayStandalonePortingToggle from '../eir-prepay/prepay-handset-details/PrepayStandalonePortingToggle';
// import RootContext from '../../../util/root.context';
// import HandsetContext from './HandsetContext.context';

const HandsetDetails = ({
  variant,
  loadingHandset,
  handsetInfo,
  selected,
  selectVariant,
  onPortingChange,
  setIsStandaloneHandset,
  handsetJourney,
  handleClick,
  phoneCost,
  upfrontPrice,
  isStandaloneHandset,
  selectedSIMType,
  setSelectedSIMType,
  equipmentSimTypes,
  cmsData,
  setIsPrepayHandset,
  handsetCode,
  addons,
  setAddons,
}) => (
  <Stack spacing={3} sx={{ pl: { xs: 0, sm: 4, md: 0 }, pt: { xs: 2, sm: 0 } }}>
    {/* title */}
    <HandsetTitle
      model={handsetInfo.model}
      upfrontPrice={upfrontPrice}
      price={variant?.price}
      phoneCost={phoneCost}
      brand={handsetInfo.brand}
      loadingHandset={loadingHandset}
      handsetJourney={handsetJourney}
    />
    {/* specification and description */}
    <HandsetSpecification
      specs={variant?.specs}
      description={handsetInfo.description}
      loadingHandset={loadingHandset}
    />
    {/* choose color */}
    <HandsetColorSelector
      colors={handsetInfo.colors}
      loadingHandset={loadingHandset}
      selected={selected}
      selectVariant={selectVariant}
    />
    {/* choose storage */}
    <HandsetStorageSelector
      storages={handsetInfo.storages}
      loadingHandset={loadingHandset}
      selected={selected}
      selectVariant={selectVariant}
    />
    {!getCookie('PREPAY_STANDALONE_HANDSET') &&
      getCookie('cart_Type') !== 'CHANGE_OFFER' &&
      equipmentSimTypes === 'HYBRID' && (
        <HandsetsSimTypeSelector
          selectedSIMType={selectedSIMType}
          setSelectedSIMType={setSelectedSIMType}
          equipmentSimTypes={equipmentSimTypes}
          cmsData={cmsData}
        />
      )}
    {!getCookie('PREPAY_STANDALONE_HANDSET') && equipmentSimTypes === 'ESIM' && (
      <ESIMOnlyHansetInfo
        selectedSIMType={selectedSIMType}
        setSelectedSIMType={setSelectedSIMType}
        equipmentSimTypes={equipmentSimTypes}
        cmsData={cmsData}
      />
    )}
    {handsetJourney &&
      (getCookie('cart_Type') !== 'CHANGE_OFFER' || !getCookie('cart_Type')) &&
      !getCookie('PREPAY_STANDALONE_HANDSET') && (
        <StandalonePortingToggle
          storages={handsetInfo.storages}
          selected={selected}
          setIsStandaloneHandset={setIsStandaloneHandset}
          onPortingChange={onPortingChange}
          loadingHandset={loadingHandset}
          handleClick={handleClick}
          isStandaloneHandset={isStandaloneHandset}
        />
      )}
    {getCookie('PREPAY_STANDALONE_HANDSET') && (
      <PrepayStandalonePortingToggle
        storages={handsetInfo.storages}
        selected={selected}
        setIsStandaloneHandset={setIsStandaloneHandset}
        loadingHandset={loadingHandset}
        handleClick={handleClick}
        setIsPrepayHandset={setIsPrepayHandset}
        handsetCode={handsetCode}
        addons={addons}
        setAddons={setAddons}
      />
    )}
  </Stack>
);

export default HandsetDetails;
